import { ShieldCheck, UserCheck, Cpu, Timer, MapPin } from "lucide-react";
import { USPS, IMAGES } from "@/lib/site";

const ICONS = { ShieldCheck, UserCheck, Cpu, Timer, MapPin };

export default function WhyChoose() {
  return (
    <section
      id="why-choose"
      data-testid="why-choose-section"
      className="bg-white border-y border-gray-100"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 py-16 md:py-24">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6">
            <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#0369A1]">
              Why Vinodha
            </span>
            <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B2545]">
              Built around accuracy, comfort &amp; speed.
            </h2>
            <p className="mt-4 text-[#64748B] leading-relaxed">
              Families across Hosa Road, Hebbagodi and Electronic City trust us for caring,
              accurate diagnostics — with a female consultant radiologist for the comfort of
              our women patients.
            </p>
          </div>
          <div className="lg:col-span-6">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-br from-[#E0F2FE] to-[#CCFBF1] rounded-[1.75rem] -z-10" />
              <img
                src={IMAGES.about}
                alt="Doctor reassuring an expecting Indian mother during a consultation at Vinodha Diagnostics"
                loading="lazy"
                className="w-full h-[280px] sm:h-[340px] object-cover rounded-[1.5rem] shadow-lg"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {USPS.map((u, i) => {
            const Icon = ICONS[u.icon] ?? ShieldCheck;
            return (
              <div
                key={u.title}
                data-testid={`usp-${i}`}
                className="group relative bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-md hover:-translate-y-1 transition-all"
              >
                <div className="grid place-items-center w-12 h-12 rounded-xl bg-[#F0FDFA] text-[#0D9488] group-hover:bg-[#14B8A6] group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" strokeWidth={2.2} />
                </div>
                <h3 className="font-display mt-5 text-lg font-bold text-[#0B2545]">
                  {u.title}
                </h3>
                <p className="mt-1.5 text-sm text-[#64748B] leading-relaxed">{u.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
